export default __webpack_public_path__ + "static/media/conventus-4.ffe64909.png";